import "./detials.css"
import { useNavigate } from "react-router-dom";

function SixServices(){
                      const navigate = useNavigate();

    return(
        <>
        <div className="servicedetials">
            <div className="row">
               <div className="col-md-12">
   <div className="box">
    <i className="fas fa-apple-alt"></i>
    <h4>Clinical Nutrition Service</h4>
    <p>
        Provides personalized dietary plans for cases of obesity, malnutrition, and metabolic diseases such as diabetes and high cholesterol, designed by certified nutrition specialists. The program includes weekly follow-up sessions to assess progress and adjust plans based on individual response, along with educational workshops on preparing healthy meals and changing unhealthy eating habits.
    </p>
    <p>July 14, 2025</p>
</div>
</div>
            </div>
           <div className="row  m-2">
  <div className="buttons">
  
     <button
      className="btn w-100 btn-warning m-2"
      onClick={() => navigate(-1)}
    >
      <i className="fas fa-exclamation-triangle w-100"></i>
      Return to Service
    </button>

  
  </div>
</div>
        </div>
        </>
    )
}
export default SixServices